import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[capMinDate]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MinDateDirective,
      multi: true
    }
  ]
})
export class MinDateDirective implements Validator {
  @Input('capMinDate')
  isoDate: string;

  validate(c: AbstractControl): ValidationErrors | null {
    if (!this.isoDate) {
      throw new Error("Input 'isoDate' not set. Example usage: [minDate]='2020-01-01'");
    }

    if (c.value === null) {
      return null;
    }

    const min = new Date(this.isoDate);
    const selectedDate = new Date(c.value);

    if (selectedDate < min) {
      return {
        'date-minimum': {
          'date-minimum': min,
          actual: selectedDate
        }
      };
    }
    return null;
  }
}
